import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { TokenService } from '../token/token.service';
import { environment as env } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    constructor(
        private translateService: TranslateService,
        private tokenService: TokenService
    ) { }

    public updateTheme(url: string, is404: boolean = false) {
        if (is404) {
            document.title = '404';
            return;
        }

        this.translateService.get('appTitle').subscribe((res: string) => {
            document.title = res;
        });

        if (!url) {
            // console.warn('Theme CSS URL is empty. Skipping update.');
            return;
        }

        // Decode if it's double-encoded
        url = decodeURIComponent(url.replace(/^"(.*)"$/, '$1'));

        // Validate URL format
        if (!this.isValidUrl(url)) {
            console.warn('Invalid Theme CSS URL. Skipping update.');
            return;
        }

        // Append timestamp to force fresh load
        url = `${url}?v=${new Date().getTime()}`;

        let themeLink = document.getElementById('theme-css') as HTMLLinkElement;

        if (themeLink) {
            themeLink.href = url; // Update existing link
        } else {
            themeLink = document.createElement('link');
            themeLink.id = 'theme-css';
            themeLink.rel = 'stylesheet';
            themeLink.href = url;
            document.head.appendChild(themeLink);
        }

        themeLink.onload = () => console.log('Theme loaded:', url);
        themeLink.onerror = () => console.error('Failed to load theme:', url);
    }

    private isValidUrl(url: string): boolean {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    }

    public updateFavicon(url: string) {
        if (!url) return;

        let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
        if (!favicon) {
            favicon = document.createElement("link");
            favicon.rel = "icon";
            document.head.appendChild(favicon);
        }
        favicon.href = url;

        this.tokenService.setLocalToken(env.TokenKeys.Favicon, url);
    }
}
